import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import rootReducer from '../reducers';
import rootSaga from '../sagas';
import { routerMiddleware } from 'react-router-redux';
import initialState from '../reducers/initialState';
import Api from '../api';
import { wsMiddleware, crashReporterMiddleware } from '../middlewares';

const history = createHistory();
const reduxRouterMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();
const middleware = [crashReporterMiddleware, reduxRouterMiddleware, sagaMiddleware, wsMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

Api.store = store;

// then run the saga
sagaMiddleware.run(rootSaga);

export default store;
